export function wrapSpaces(value: string) {
  return value.replace(/ +/g, ' ').replace(/ ;+/g, ';').trim();
}
